<div class="d-flex justify-content-between">
    <h4 class="mr-auto pt-3 f-bold main-heading">Quick Add New User</h4>
    <button class="btn" mat-icon-button (click)="dialogRef.close(false)" type="button">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
</div>

<div class="row">
    <div class="col-12">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
            <span class="purpleLoader"></span>
        </div>
        <div *ngIf="!progress_spinner">
            <form [formGroup]="createPromoForm">
                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">First name</label>
                            <input type="text" class="form-control" placeholder="First name"
                                formControlName="firstName" />
                            <mat-error class="ml-3"
                                *ngIf=" createPromoForm.controls['firstName'].touched && createPromoForm.controls['firstName'].hasError('required') ">
                                First name is required
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Last name</label>
                            <input type="text" class="form-control" placeholder="Last name"
                                formControlName="lastName" />
                            <mat-error class="ml-3"
                                *ngIf=" createPromoForm.controls['lastName'].touched && createPromoForm.controls['lastName'].hasError('required')">
                                Last name is required
                            </mat-error>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Email address</label>
                            <input type="text" class="form-control" placeholder="Email address"
                                formControlName="email" />
                            <mat-error class="ml-3"
                                *ngIf=" createPromoForm.controls['email'].touched && createPromoForm.controls['email'].hasError('required')">
                                Email is required
                            </mat-error>
                        </div>
                    </div>

                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Phone</label>
                            <input type="text" class="form-control" placeholder="phone : +1 (000) 000-0000"
                                formControlName="phone" (input)="applyPhoneMask($event)"
                                (change)="testPhoneData($event)" />
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['phone'].touched && createPromoForm.controls['phone'].hasError('required')">
                                Phone is required
                            </mat-error>
                        </div>
                    </div>

                </div>
                <div class="row">

                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Date of birth</label>
                            <div class="position-relative">
                                <input matInput [matDatepicker]="dobPicker" readonly [max]="getCurrentDate()"
                                    (click)="dobPicker.open()" class="form-control" placeholder="Date of birth"
                                    formControlName="dob" (dateChange)="onDateChange($event)" />
                                <mat-datepicker-toggle matSuffix [for]="dobPicker"
                                    class="date-icon"></mat-datepicker-toggle>
                                <mat-datepicker #dobPicker></mat-datepicker>
                            </div>

                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['dob'].touched && createPromoForm.controls['dob'].hasError('required')">
                                Date of birth is required
                            </mat-error>
                        </div>
                    </div>

                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Timezone</label>
                            <mat-form-field class="w-100">
                                <mat-select class="form-control" placeholder="Select display"
                                    formControlName="timezone">
                                    <mat-option *ngFor="let item of allTimeZoneList" [value]="item.timezone">
                                        {{ item?.timezone }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['timezone'].touched && createPromoForm.controls['timezone'].hasError('required')">
                                Timezone is required
                            </mat-error>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Password</label>
                            <input type="password" class="form-control" placeholder="Password"
                                formControlName="password" />
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['password'].touched && createPromoForm.controls['password'].hasError('required')">
                                Password is required
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Confirm
                                password</label>
                            <input type="password" class="form-control" placeholder="Confirm password"
                                formControlName="password_confirm" />
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['password_confirm'].touched && createPromoForm.controls['password_confirm'].hasError('required')">
                                Confirm password is required
                            </mat-error>
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.hasError('mismatch') && createPromoForm.controls['password_confirm'].touched">
                                Passwords do not match
                            </mat-error>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Postal code</label>
                            <input type="text" class="form-control" placeholder="Postal code"
                                formControlName="postal_code" />
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['postal_code'].touched && createPromoForm.controls['postal_code'].hasError('required')">
                                Postal code is required
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-6 mb-3" *ngIf="tenant != 'qc'">
                        <div class="form-group">
                            <label class="small white-space pb-1">Kroll ID</label>
                            <input type="text" class="form-control" placeholder="Kroll ID" formControlName="kroll_id" />
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['kroll_id'].touched && createPromoForm.controls['kroll_id'].hasError('required')">
                                Kroll ID is required
                            </mat-error>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Province</label>
                            <mat-form-field class="w-100">
                                <mat-select class="form-control" placeholder="Select province"
                                    formControlName="user_state_id">
                                    <mat-option *ngFor="let item of allStateList"
                                        (click)="userStateId(item.parent_id > 0 ? item.parent_id : item.id)"
                                        [value]="item.id">
                                        {{ item?.state_name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['user_state_id'].touched && createPromoForm.controls['user_state_id'].hasError('required')">
                                State is required
                            </mat-error>
                        </div>
                    </div>

                    <div class="col-6 mb-3" *ngIf="tenant != 'qc'">
                        <div class="form-group">
                            <label class="small white-space pb-1">Kroll server
                                location</label>
                            <mat-form-field class="w-100">
                                <mat-select class="form-control" placeholder="Kroll server location"
                                    formControlName="state_id">
                                    <mat-option *ngFor="let item of allStateList" [value]="item.id">
                                        {{ item?.state_name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['state_id'].touched && createPromoForm.controls['state_id'].hasError('required')">
                                Kroll server location is required
                            </mat-error>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Referral code</label>
                            <input type="text" class="form-control" placeholder="Referral code"
                                formControlName="referral_code" />
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['referral_code'].touched && createPromoForm.controls['referral_code'].hasError('required')">
                                Referral code is required
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="small white-space pb-1">Shipping
                                address</label>
                            <textarea type="text" class="form-control" placeholder="Shipping address"
                                formControlName="shipping_address" rows="1"></textarea>
                            <mat-error class="ml-3"
                                *ngIf="createPromoForm.controls['shipping_address'].touched && createPromoForm.controls['shipping_address'].hasError('required')">
                                Shipping address is required
                            </mat-error>
                        </div>
                    </div>
                </div>

                <div class="col-6 mb-3">
                    <div class="form-group">
                        <label class="small white-space pb-1">Shipping address
                            detail</label>
                        <textarea type="text" class="form-control" rows="1" placeholder="Shipping address detail"
                            formControlName="shipping_address_detail"></textarea>
                        <mat-error class="ml-3"
                            *ngIf="createPromoForm.controls['shipping_address_detail'].touched && createPromoForm.controls['shipping_address_detail'].hasError('required')">
                            Shipping address detail is required
                        </mat-error>
                    </div>
                </div>

                <button [disabled]="createPromoForm.invalid" class="custom-btn mt-3 ml-0" type="button"
                    (click)="save()">
                    {{ isEditing ? "Creating..." : "Create" }}
                </button>
            </form>
        </div>
    </div>
</div>